module.exports = __webpack_public_path__ + "static/media/video.77f35487.svg";